import React from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import useBlocRef from '../utils/useBlocRef.hook';

export default ({ children }) => {
  const blocRef = useBlocRef('appBloc');
  const history = useHistory();
  const location = useLocation();
  const userDetails = blocRef.current.userDetails$.getValue();
  const workspaceDetail = blocRef.current.userWorkspace$.getValue();
  const patientDemoAccountState = blocRef.current.isPatientDemoAccountState;

  const isRegisteredOrDemoUser = userDetails?.firstOrderStatus === 'registered' || (location.pathname !== '/patient-dashboard' && !location.pathname.includes('/patient-report'));
  const { isMediphanyWorkspace, canRequestBeforePay } = workspaceDetail;
  const storedImage = userDetails?.userPlan?.studyCount > 0;

  if (isMediphanyWorkspace && !userDetails?.availableReport && isRegisteredOrDemoUser && !patientDemoAccountState && !canRequestBeforePay && !storedImage) {
    history.push('/package-plans');
  }

  return <>{children}</>;
};
